import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '@pkg/hooks';

import { useAuthSidebar } from '@app/store/zustand';

export function useAuthFlow() {
    const { isAuthSidebarOpen, closeAuthSidebar, openAuthSidebar } = useAuthSidebar();
    const isAuthenticated = useAppSelector((state) => state.user.isRegisteredUser);
    const navigate = useNavigate();

    const [authCallback, setAuthCallback] = useState<null | (() => void)>(null);

    function protectedAction(protectedAction: () => void) {
        if (!isAuthenticated) {
            setAuthCallback(() => protectedAction);
            openAuthSidebar();
        } else {
            protectedAction();
        }
    }

    function authenticate() {
        openAuthSidebar();
    }

    function protectedRedirect(link: string) {
        if (isAuthenticated) {
            navigate(link);
            return;
        }

        protectedAction(() => navigate(link));
    }

    useEffect(() => {
        if (isAuthenticated) {
            if (isAuthSidebarOpen) closeAuthSidebar();

            if (authCallback) {
                authCallback();
                setAuthCallback(null);
            }
        }
    }, [isAuthenticated, isAuthSidebarOpen, closeAuthSidebar, authCallback]);

    return {
        authenticate,
        protectedAction,
        protectedRedirect,
    };
}
